import React, { FC, PropsWithChildren, useState } from 'react';
import { View, ScrollView } from '@tarojs/components';
import { showToast } from '@tarojs/taro';

interface IIndexesItem {
  name: string; // 列表项内容
  [key: string]: any;
}

interface IIndexesListItem {
  title: string; // 列表标题
  key: string; // 右侧导航标题
  items: IIndexesItem[]; // 每一项的内容列表
}

interface IIndexesProps {
  animation?: boolean; // 是否开启跳转过度动画
  topKey?: string; // 右侧导航第一个名称
  list: IIndexesListItem[]; // 列表
  onClick?: (item: IIndexesItem) => void; // 点击列表项触发事件
}

const Indexes: FC<PropsWithChildren<IIndexesProps>> = ({ animation = true, topKey = 'Top', list = [], onClick, children }) => {
  const [scrllViewId, setScrollViewId] = useState('');
  // 菜单列表
  const menuList = [topKey, ...list.map((listItem) => listItem.key)];

  const showToastMsg = (message: string) => {
    showToast({
      icon: 'none',
      title: message,
      mask: false,
      duration: 1500,
    });
  };

  return (
    <View className="ace-indexes">
      {/* <Toast text="" isOpened={false} duration={2000} hasMask={false} image="" /> */}
      <View className="ace-indexes-menu">
        {menuList.map((menu) => (
          <View
            onClick={() => {
              if (topKey && menu === topKey) {
                showToastMsg(topKey);
                setScrollViewId('indexes_top');
              } else {
                showToastMsg(menu);
                setScrollViewId(`ace-indexes-list-item-${menu}`);
              }
            }}
            className="ace-indexes-menu-item"
            key={menu}
          >
            {menu}
          </View>
        ))}
      </View>
      <ScrollView scrollIntoView={scrllViewId} scrollAnchoring className="ace-indexes-body" scrollY scrollWithAnimation={animation}>
        <View className="ace-indexes-content" id="indexes_top">
          {children}
        </View>
        <View className="ace-indexes-list">
          {list.map((listItem) => (
            <View className="ace-indexes-list-item" key={listItem.key}>
              <View className="ace-indexes-list-item-title" id={`ace-indexes-list-item-${listItem.key}`}>
                {listItem.title}
              </View>
              {listItem.items && (
                <View className="ace-indexes-list-item-body">
                  {listItem.items.map((item) => (
                    <View
                      onClick={() => {
                        if (onClick) {
                          onClick(item);
                        }
                      }}
                      className="ace-indexes-list-item-body-item"
                      key={item.name}
                    >
                      {item.name}
                    </View>
                  ))}
                </View>
              )}
            </View>
          ))}
        </View>
      </ScrollView>
    </View>
  );
};

export default Indexes;
